import { lazy } from 'react';

export default lazy(() =>
  import(
    /* webpackChunkName: 'supplier_tables_list_page' */ './SupplierTablesListPage'
  ),
);
